import { ReactComponent as ToastCheck } from "../../assets/icons/toastCheck.svg";
import { ReactComponent as ToastNotice } from "../../assets/icons/toastNotice.svg";
import { ReactComponent as ToastError } from "../../assets/icons/toastError.svg";
import { ReactComponent as ToastWarn } from "../../assets/icons/toastWarn.svg";
import { ReactComponent as ToastDelete } from "../../assets/icons/toastDelete.svg";
import { ReactComponent as CloseIcon } from "../../../console/assets/icons/closeGrayIcon.svg";
import { useEffect, useState } from "react";

type ToastProps = {
    type: "success" | "notice" | "error" | "warning" | "delete";
    message?: string;
    onClose: () => void;
    onUndo?: () => void;
    height?: boolean;
};
const Toast = ({ type, message, onClose, onUndo, height }: ToastProps) => {
    const [timeLeft, setTimeLeft] = useState(5);

    useEffect(() => {
        if (type === "delete" && timeLeft > 0) {
            const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
            return () => clearTimeout(timer);
        }

        if (timeLeft === 0) {
            onClose();
        }
    }, [timeLeft, type, onClose]);

    const handleUndo = () => {
        onUndo?.();
        onClose();
    };

    const iconMap = {
        success: <ToastCheck />,
        notice: <ToastNotice />,
        error: <ToastError />,
        warning: <ToastWarn />,
    };

    const borderColorMap = {
        success: "border-success",
        notice: "border-skyblue",
        error: "border-error",
        warning: "border-warning",
    };

    const formatDateTime = () => {
        const now = new Date();

        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        const seconds = String(now.getSeconds()).padStart(2, "0");

        return `${year}.${month}.${day} ${hours}:${minutes}:${seconds}`;
    };

    const currentTime = formatDateTime();

    return type === "delete" ? (
        <div className="w-[360px] py-5 px-4 bg-error relative rounded-xl">
            <CloseIcon className="absolute top-2 right-2 cursor-pointer" onClick={onClose} />
            <div className="text-white flex items-center gap-2">
                <ToastDelete />
                <p className="text-bold">{timeLeft}초 후 삭제됩니다.</p>
                <button className="underline" onClick={handleUndo}>
                    실행취소
                </button>
            </div>
        </div>
    ) : (
        <div
            className={`w-[360px] ${height ? "h-[112px]" : "h-[88px]"} border-l-4 ${borderColorMap[type]} rounded-xl bg-white shadow-lg relative`}
        >
            <CloseIcon className="absolute top-2 right-2 cursor-pointer" onClick={onClose} />
            <div className="flex items-start gap-2 px-4 py-5">
                {iconMap[type]}
                <div className="flex flex-col gap-1">
                    <p className="font-bold whitespace-pre-line" dangerouslySetInnerHTML={{ __html: message || "" }} />{" "}
                    <p className="text-sm text-gray2">{currentTime}</p>
                </div>
            </div>
        </div>
    );
};

export default Toast;
